export default __webpack_public_path__ + "static/media/beraksi-phone11.655452cc.png";